module.exports = __webpack_public_path__ + "img/Google-logo.93be14ac.png";